var legends = {

    "radar": {
        "r": [1, 0, 1, 255, 231, 255, 214, 255, 173],
        "g": [160, 236, 144, 255, 192, 144, 0, 0, 144],
        "b": [246, 236, 0, 0, 0, 0, 0, 240, 240],
        "v": [10, 15, 25, 30, 35, 40, 50, 60, 70]
    },
    "DBZSWC": {
        "r": [1, 0, 1, 255, 231, 255, 214, 255, 173],
        "g": [160, 236, 144, 255, 192, 144, 0, 0, 144],
        "b": [246, 236, 0, 0, 0, 0, 0, 240, 240],
        "v": [10, 15, 25, 30, 35, 40, 50, 60, 70]
    },
    "temp": {
        "r": [21, 0, 0, 132, 76, 255, 74],
        "g": [0, 69, 109, 250, 254, 149, 0],
        "b": [37, 195, 214, 152, 50, 0, 6],
        "v": [-90, -30, 0, 10, 20, 30, 40],
    },

    "dew2": {
        "r": [21, 51, 0, 132, 199, 236, 74],
        "g": [0, 4, 109, 250, 254, 149, 0],
        "b": [37, 85, 214, 152, 50, 0, 6],
        "v": [-100, -10, 0, 10, 20, 30, 40],
    },
    "wind": {
        "r": [97, 77, 109, 161, 147, 95, 91],
        "g": [113, 142, 160, 108, 76, 101, 136],
        "b": [183, 121, 55, 91, 145, 160, 161],
        "v": [0, 10, 20, 30, 40, 50, 60]
    },
    "wind3": {
        "r": [235, 225, 215, 196, 146, 255, 255, 255, 255, 197, 182, 168, 153, 153, 95, 0],
        "g": [225, 210, 195, 165, 90, 255, 233, 216, 199, 237, 233, 228, 224, 224, 206, 0],
        "b": [241, 234, 227, 213, 178, 0, 0, 0, 0, 4, 4, 5, 6, 6, 10, 255],
        "v": [0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30],
    },
    "wind6": {
        "r": [235, 225, 215, 196, 146, 255, 255, 255, 255, 197, 182, 168, 153, 153],
        "g": [225, 210, 195, 165, 90, 255, 233, 216, 199, 237, 233, 228, 224, 224],
        "b": [241, 234, 227, 213, 178, 0, 0, 0, 0, 4, 4, 5, 6, 6],
        "v": [0, 4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52],
    },
    "vis": {
        "r": [164, 171, 162, 129, 74, 31, 65, 153],
        "g": [58, 54, 60, 162, 164, 164, 127, 153],
        "b": [154, 107, 59, 59, 57, 168, 197, 153],
        //"v": [24.1,15,10,6,3,1.2,0.8,0],
        "v": [0, 0.8, 1.2, 3, 6, 10, 15, 24.1]
    },
    "ic": {
        "r": [175, 0, 132],
        "g": [238, 105, 112],
        "b": [238, 225, 255],
        "v": ["轻度(<50)", "中度(50-80)", "严重(>=80)"],
    },
    "Ic": {
        "r": [89, 63, 180],
        "g": [161, 90, 82],
        "b": [186, 171, 92],
        "v": [1, 2, 3],
    },
    "Is": {
        "r": [174, 174, 171, 146, 103, 66, 54, 56, 56, 56, 56, 56],
        "g": [110, 136, 146, 157, 174, 174, 170, 158, 141, 132, 108, 71],
        "b": [56, 56, 56, 56, 58, 124, 154, 173, 174, 174, 163, 116],
        "v": [0.1, 0.15, 0.2, 0.3, 0.4, 0.6, 0.8, 1, 2, 3, 4, 5],
    },
    "dutton": {
        "r": [171, 223, 224, 232],
        "g": [161, 177, 88, 23],
        "b": [14, 6, 37, 42],
        "v": ["轻度(25-30)", "中度(30-35)", "重度(35-40)", "严重(>40)"]
    },
    "ws": {
        "r": [97, 73, 77, 98, 162, 150],
        "g": [113, 145, 142, 164, 113, 74],
        "b": [183, 169, 126, 58, 88, 141],
        "v": [0, 3, 5, 10, 15, 20],
    },
    "fs": {
        "r": [172, 135, 124, 111, 101],
        "g": [172, 119, 104, 87, 74],
        "b": [172, 84, 59, 26, 2],
        "v": [300, 690, 1390, 1600, 2000],
    },
    "cams": {
        "r": [172, 126, 124, 110, 105, 100],
        "g": [172, 107, 104, 86, 80, 73],
        "b": [172, 63, 58, 25, 12, 0],
        "v": [0, 30, 60, 300, 600, 800],
    },
    "rain": {
        "r": [59, 59, 59, 58, 58, 58, 58, 50, 74, 129, 162, 162, 171, 164],
        "g": [100, 120, 128, 133, 140, 147, 163, 166, 164, 162, 162, 60, 54, 58],
        "b": [162, 162, 162, 162, 162, 162, 162, 111, 57, 59, 59, 59, 107, 154],
        "v": [0.1, 0.3, 0.5, 1, 1.5, 2, 2.5, 3, 6, 10, 15, 25, 30, 35]
    },
    "rh": {
        "r": [174, 54, 56, 56, 56, 56, 56, 56],
        "g": [110, 175, 158, 142, 133, 111, 71, 71],
        "b": [56, 148, 174, 174, 174, 166, 116, 116],
        "v": [0, 10, 30, 45, 60, 75, 90, 100]
    },
    "infImg": {
        "r": [244, 218, 211, 245, 239, 221, 220, 220],
        "g": [244, 217, 211, 245, 191, 39, 23, 16],
        "b": [244, 217, 211, 245, 184, 36, 36, 39],
        "v": [260, 250, 240, 230, 220, 210, 200, "k"]
    },
    "planeSpeed": {
        "r": [144, 0, 6, 144, 239],
        "g": [253, 151, 18, 7, 1],
        "b": [255, 255, 255, 255, 236],
        "v": [0, 300, 600, 800, 1000]
    },
    "DCC": {
        "r": [50, 150, 255, 120],
        "g": [50, 255, 160, 50],
        "b": [255, 0, 0, 160],
        "v": ["弱", "中", "强", "极强"]
    },
    "FOG": {
        "r": [130, 255, 248, 173],
        "g": [183, 241, 135, 8],
        "b": [214, 247, 81, 38],
        "v": ["3.0", "4.0", "5.0", "6.0"]
    },
    "DSI": {
        "r": [250, 255, 252, 155, 255, 200],
        "g": [255, 205, 105, 5, 5, 240],
        "b": [155, 100, 10, 0, 2, 132],
        "v": ["浮尘", "扬沙", "沙尘暴", "强沙尘暴", "特强沙尘暴", "未定义"]
    },
}

legends["gust"] = legends["wind"];
var colorsDbzLegend = {};
colorsDbzLegend.r = [];
colorsDbzLegend.g = [];
colorsDbzLegend.b = [];
colorsDbzLegend.v = [];
for (var threshold in glColor.dbz) {
    var glColorRgbStr = glColor.dbz[threshold].replace("rgb(", "").replace(")", "").split(",");
    colorsDbzLegend.v.push((threshold * 255 / 2).toFixed(0));
    colorsDbzLegend.r.push(glColorRgbStr[0]);
    colorsDbzLegend.g.push(glColorRgbStr[1]);
    colorsDbzLegend.b.push(glColorRgbStr[2]);
}
legends["dbz"] = colorsDbzLegend;


function renderLegend(str, containerId) {
    var containerDiv = $("#legend");
    if (containerId) {
        containerDiv = $("#" + containerId);
    }

    var type = null;
    var symbol = "dBZ";
    switch (str) {
        case "dbz":
            type = 'dbz';
            symbol = "dBZ";
            break;
        case "DBZSWC":
            type = 'DBZSWC';
            symbol = "dBZ";
            break;
        case "radarImg":
            type = 'radar';
            symbol = "dBZ";
            break;
        case "vis":
            type = 'vis';
            symbol = "km";
            break;
        case "temp":
            type = 'temp';
            symbol = "°C";
            break;
        case "wind":
            type = 'wind';
            symbol = "m/s";
            break;
        case "infImg":
            type = 'infImg';
            symbol = "";
            break;
        case "ic":
            type = 'ic';
            symbol = "%";
            break;
        case "dutton":
            type = 'dutton';
            symbol = " ";
            break;
        case "ws":
            type = 'ws';
            symbol = "m/s";
            break;
        case "fs":
            type = 'fs';
            symbol = "μg/m³";
            break;
        case "cams":
            type = 'cams';
            symbol = "μg/m³";
            break;
        case "rain":
            type = 'rain';
            symbol = "mm";
            break;
        case "dew2":
            type = 'temp';
            symbol = "°C";
            break;
        case "rh":
            type = 'rh';
            symbol = "%";
            break;
        case "planeSpeed":
            type = "planeSpeed";
            symbol = "km/h"
            break;
        case "gust":
            type = "gust";
            symbol = "m/s";
            break;
        case "DCC":
            type = "DCC";
            symbol = "对流强度";
            break;
        case "FOG":
            type = "FOG";
            symbol = "水汽浓度指数";
            break;
        case "DSI":
            type = "DSI";
            symbol = "";
            break;
        default:
            type = "radar";
            symbol = "dbz";
    }
    if (type == "1") {
        containerDiv.css("display", "none");
        return;
    }

    if (type != null) {
        var t = legends[type]

        var v = t.v;
        var r = t.r;
        var g = t.g
        var b = t.b
        var span = "<span style='color:rgb(" + (255 - r[0]) + "," + (255 - g[0]) + "," + (255 - b[0]) + ")'>" + symbol + "</span>";
        var rgb = "rgba(" + r[0] + "," + g[0] + "," + b[0] + "),";

        for (var i = 0; i < v.length; i++) {
            span += "<span style='padding: 0px 10px;font-size: 10px;margin-left:5px;color:rgb(" + (255 - r[i]) + "," + (255 - g[i]) + "," + (255 - b[i]) + ")'>" + v[i] + "</span>"
            if (i == v.length - 1) {
                rgb += "rgba(" + r[i] + "," + g[i] + "," + b[i] + ")";
            } else {
                rgb += "rgba(" + r[i] + "," + g[i] + "," + b[i] + "),";
            }
        }
        containerDiv.html(span);
        containerDiv.css("background-image", "linear-gradient(to right, " + rgb + ")").css("display", "inline");

    } else {
        containerDiv.html("暂无图例");
        containerDiv.css("background-image", "none");
    }

}


window.legends = legends;
window.renderLegend = renderLegend;